<div class="lp_profile_details">
    <div class="profile_details_content">
        <!-- Payment accordion -->
        <div id="paymentAccordion" class="payment-accordion">
            <div class="card">
             <div class="card-header">
                    <a (click)="authorizePaymentGateWay()">
                        <span class="card-text">Add Debit/Credit Card
                            Details</span>
                        <span class="payment-icons"><img src="../assets/images/payment-method.svg" alt=""></span>
                    </a>
                </div>
                <div id="iframe_holder" class="center-block" style="width: 90%; max-width: 1000px;">
                    <iframe id="add_pci_payment" title="pci payment" class="embed-responsive-item panel" name="add_pci_payment" width="100%" height="650px" style="display: none;overflow:auto;border:0;"></iframe>
                  </div>
                
                  <form id="send_pci_token" action="" method="post" target="add_pci_payment">
                      <input type="hidden"  value="" name="token" id="token" />       
                  </form>
                
        </div>
    </div>
</div>
